export default {
    'SET_ULTIMAS_MENSAGENS'(state, data) {
        state.ultimasMensagens = data
    },
    'SET_TEMPLATES_CAMPANHA' (state, data) {
        state.templates_campanha = data
    },
    'SET_AGENDAMENTOS' (state, data) {
        state.agendamentos = data
    },
    'SET_ULTIMOS_AGENDAMENTOS' (state, data) {
        state.ultimosAgendamentos = data
    },
    'SET_MENSAGENS_ERRO' (state, data) {
        state.mensagens_erro = data
    },

}



// WEBPACK FOOTER //
// ./src/store/modules/mensagens/mutations.js